import { useTranslation } from "react-i18next"

import Dialog from "@/components/dialog/Dialog"
import BasicButton from "@/components/button/BasicButton"
import { useUpsertPlayerLeaveMutation } from "@/hooks/api/usePlayerQuery"
import { createGlobalStore } from "@/stores/global"

export default function RemovePlayerDialog({
  selectedPlayer,
  setSelectedPlayer,
  open,
  onClose,
}: {
  selectedPlayer: number | undefined
  setSelectedPlayer: (id: number | undefined) => void
  open: boolean
  onClose: () => void
}) {
  const { t } = useTranslation()
  const { mutate: leavePlayer } = useUpsertPlayerLeaveMutation()
  const setSnackBar = createGlobalStore((state) => state.setSnackBar)

  const onRemove = () => {
    if (!selectedPlayer) {
      return
    }

    leavePlayer(selectedPlayer)
    setSelectedPlayer(undefined)
    setSnackBar({ message: t("messages.successDelete"), severity: "success", open: true })
    onClose()
  }

  return (
    <Dialog
      title={t("confirm")}
      open={open}
      onClose={onClose}
      maxWidth="400px"
      footer={
        <>
          <BasicButton type="default-outlined" size="md" onClick={onClose}>
            {t("button.cancel")}
          </BasicButton>
          <BasicButton type="danger-outlined" size="md" onClick={onRemove}>
            {t("button.remove")}
          </BasicButton>
        </>
      }>
      {t("messages.confirmRemove")}
    </Dialog>
  )
}
